import { httpRequest } from "services/build-request";

export const getSalesIb = async ({ filters }) => {
  const route = "challenge-orders/ib-registers";
  const { success, data } = await httpRequest({ route, params: filters});
  return { success, data };
};

export const createRepeat = async () => {
  const route = "challenge-orders/create-repeat";
  const { success, message } = await httpRequest({ route, method: 'POST' });
  return { success, message };
}

export const getSalesIbCount = async () => {
  const route = "challenge-orders/ib-registers-count";
  const { success, data } = await httpRequest({ route });
  return { success, data };
};

export const getFreeChallengesIb = async ({ pagination }) => {
  const route = "challenge-orders/ib/free-accounts";
  const { success, data } = await httpRequest({ route, headers: pagination });
  return { success, data };
};